import { Injectable, NgZone, signal } from '@angular/core';
import { switchAdvisor } from '../models/model';
import config from '../../../assets/config.json';
@Injectable({
  providedIn: 'root',
})
export class switchAdvisorService {
  private cookieName = btoa('switchedAdvisor');
  switchedAdvisor = signal<switchAdvisor | null>(this.loadswitchedAdvisor());
  showDisplayer: boolean = false; // Flag to control the displayer

  // eslint-disable-next-line no-unused-vars
  constructor(private ngZone: NgZone) {}

  switchAdvisor(userDetails: switchAdvisor) {
    this.switchedAdvisor.set(userDetails);
    this.setCookie(this.cookieName, btoa(JSON.stringify(userDetails)));
    this.ngZone.runOutsideAngular(() => {
      window.location.reload();
    });
    this.showSwitchAdvisorDisplayer(); // Show the displayer after switching advisor
  }

  stopswitchAdvisor() {
    this.switchedAdvisor.set(null);
    this.deleteCookie(this.cookieName);
    this.ngZone.runOutsideAngular(() => {
      window.location.reload();
    });
    this.showSwitchAdvisorDisplayer(); // Show the displayer after switching advisor
  }

  private setCookie(name: string, value: string) {
    const expires = new Date(Date.now() + Number(config.idleAppTimeOut)).toUTCString();
    document.cookie = `${name}=${value}; path=/; Secure; SameSite=Strict; expires=${expires}`;
    //  No expiration → Remains until manually deleted
  }

  loadswitchedAdvisor(): switchAdvisor | null {
    const match = document.cookie.match(new RegExp('(^| )' + this.cookieName + '=([^;]+)'));
    return match ? JSON.parse(atob(match[2])) : null;
  }

  private deleteCookie(name: string) {
    document.cookie = `${name}=; path=/; Secure; SameSite=Strict; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
  }
  stopSwtichAdvisorLogout() {
    this.deleteCookie(this.cookieName);
  }
  showSwitchAdvisorDisplayer() {
    this.showDisplayer = true; // Show the displayer after switching advisor
    setTimeout(() => {
      this.showDisplayer = false; // Hide the displayer after 5 seconds
    }, 6000); // Hide the displayer after 5 seconds
  }
}
